// extracted by mini-css-extract-plugin
module.exports = {"message":"CreditOffer_message__Axyd0"};